// extracted by mini-css-extract-plugin
export default {"fields":"SBQv9M","mobile":"X0EgTS"};